import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine, Reveal } from "@/components/Reveal";
import CTABand from "@/components/CTABand";

const UPCOMING = [
  "What to Consider Before a Structured Cabling Installation",
  "Planning a Multi-Location POS Deployment: A Practical Checklist",
  "How to Prepare a Business Location for an IT Equipment Rollout",
  "What Businesses Should Know Before Installing Digital Signage",
  "Planning a Multi-Site Technology Deployment",
];

export default function Insights() {
  useEffect(() => {
    document.title = "Insights — LEDOS Enterprise Solutions";
  }, []);

  return (
    <main data-testid="insights-page">
      <section className="relative bg-ink pt-44 pb-20 md:pb-28 overflow-hidden">
        <div aria-hidden="true" className="absolute inset-0 grid-bg" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <MaskedLine delay={0.1}>
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-signal mb-8">
              Insights
            </p>
          </MaskedLine>
          <h1 className="font-display font-black tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-7xl max-w-4xl">
            <MaskedLine delay={0.25}>Practical guides,</MaskedLine>
            <MaskedLine delay={0.38}>
              <span>
                written from <span className="text-signal">the field.</span>
              </span>
            </MaskedLine>
          </h1>
          <Reveal delay={0.5} className="mt-10 max-w-2xl">
            <p className="text-base md:text-lg leading-relaxed text-zinc-400">
              Our first articles are in preparation. Each one is a practical, educational guide
              tied directly to the services LEDOS delivers — no filler content.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ink pb-24 md:pb-36">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="border-t border-line">
            {UPCOMING.map((title, i) => (
              <Reveal key={title} delay={i * 0.05}>
                <div
                  data-testid={`insights-upcoming-${i + 1}`}
                  className="grid md:grid-cols-12 gap-4 items-center py-8 border-b border-line px-2 md:px-6"
                >
                  <span className="md:col-span-1 font-display text-3xl font-black tracking-tighter text-outline-signal">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="md:col-span-8 font-display text-xl md:text-2xl font-bold tracking-tight text-white">
                    {title}
                  </h2>
                  <span className="md:col-span-3 md:text-right font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-600">
                    In preparation
                  </span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <Link
              to="/contact"
              data-testid="insights-cta-contact"
              className="group mt-12 inline-flex items-center gap-2 border border-line text-white font-mono text-xs tracking-[0.15em] uppercase px-6 py-4 hover:border-signal hover:text-signal transition-colors duration-300"
            >
              Have a question now? Ask us directly
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>
      </section>

      <CTABand />
    </main>
  );
}
